import { CurrentUserService } from './../../../core/services/current-user.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { MassUploadSteps } from 'src/app/shared/enum/mass-upload-steps.enum';
import { environment } from 'src/environments/environment';
import { UserMassUploadService } from './services/user-mass-upload.service';
import { MassUploadUserTemplateUrl } from 'src/app/shared/enum/mass-user-template.enum';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-user-mass-upload',
  templateUrl: './user-mass-upload.component.html',
  styleUrls: ['./user-mass-upload.component.scss']
})
export class UserMassUploadComponent implements OnInit {

  constructor(private _userMassService: UserMassUploadService,
    private location:Location,
    private _gaSvc: GoogleAnalyticsService,
    private currentUserService: CurrentUserService,
    public header: HeaderService,
    private _redirectUrl: RedirctUrlService,
    public appNotificationsService: AppNotificationService) { }

  public fileValidationResult: any = { valid: true, message: '' };
  public currentStep: string = MassUploadSteps.UPLOAD;
  public MassUploadSteps = MassUploadSteps;
  currentUser: string = '';
  public loading: boolean = false;
  public notifications: any[] = [];

  async ngOnInit() {
    this.header.headerTitle = "Add Users";
    this.header.metrics = [];

    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
      this._gaSvc.register('Mass Upload User', 'Navigated to Mass Upload page.',this.currentUserService.user.username);
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {

  }

  /**
   * Check files validity and upload to server for processing
   * @param file
   */
  public fileSelected(file: File): void {
    this._userMassService.setUploadedFile(file);
    this.loading = true
    // check for file type and size
    this.fileValidationResult = this._userMassService.validateFileHeader();

    if (this.fileValidationResult.valid) {
      // Upload to server for checking valid/invalid/duplicate suppliers
      this._userMassService.validateUsers().subscribe((result: any) => {
        // set total count of suppliers in excel file
        this._userMassService.setTotalUsers(result.total);
        this._userMassService.setBatchId(result.batchId);
        // go to review stage
        this.currentStep = MassUploadSteps.REVIEW;
        this._gaSvc.register('Mass Upload User', 'File Uploaded for mass upload.', this.currentUser);
        this.loading = false;
      }, (err) => {
        // show error if it failed loading file to server.
        if (err.status === 400) {
          this.fileValidationResult = {
            valid: false,
            message: err.error.message
          }
          this._gaSvc.register('Mass Upload User', 'Blank file uploaded.', this.currentUser);
        }
        else {
          this.fileValidationResult = {
            valid: false,
            message: 'Error Occured While Loading Users.'
          }
          this._gaSvc.register('Mass Upload User', 'Failed Uploading file.', this.currentUser);
        }
        this.loading = false;
      });
    }
    else this.loading = false;
  }

  /**
   * Download supplier template for mass upload
   */
  public downloadTemplate() {
    this._gaSvc.register('Mass Upload User', 'Downloaded template', this.currentUser);
    if (!environment.runtime.envName) {
      window.location.href = MassUploadUserTemplateUrl.PROD;
    } else {
      window.location.href = MassUploadUserTemplateUrl.NON_PROD;
    }
  }

  onRedirectHandler(event) {
    this._redirectUrl.onLogoutHandler(event);
  }

  onBackEventHandler() {
    this.location.back();
  }
}
